import { DISALLOWED_COLOR_VALUES as e } from "../../constants.js";
import { tinycolor as t } from "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
//#region src/specs/nodes/spec-util.ts
var n = (e) => e.getAlpha() < 1 ? e.toHex8String() : e.toHexString(), r = (r) => {
	if (r) {
		let i = t(r);
		if (i.isValid() && !e.includes(r)) return n(i);
	}
	return "";
};
//#endregion
export { r as getBackgroundColor, n as toAlphaPreservingHex };
